import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {secureStorage} from "../shared/functions/secure-storage";

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  filterChangedSubject = new BehaviorSubject<string>(undefined);
  outOfTableSubject = new BehaviorSubject<boolean>(undefined);
  ///////////////
  drawerOpen = new BehaviorSubject<boolean>(false);
  drawerOpen$ = this.drawerOpen.asObservable();
  ///////////////
  challengeId = new BehaviorSubject<any>(undefined);
  challengeIdObservable$ = this.challengeId.asObservable();
  ///////////////
  surveyId = new BehaviorSubject<any>(undefined);
  surveyIdObservable$ = this.surveyId.asObservable();
  ///////////////
  crumbs = new BehaviorSubject<any>(undefined);
  crumbsObservable$ = this.crumbs.asObservable();
  ///////////////
  statistics_data = new BehaviorSubject<any>(undefined);
  statistics_dataObservable$ = this.statistics_data.asObservable();

  constructor(private http: HttpClient) {
  }

  getMyCountryByIp(): any {
    this.http.get('https://api.ipify.org?format=json').subscribe((data: any) => {
      this.http.get(`https://ipinfo.io/${data.ip}/json?token=e48dad5f0ed21d`).subscribe((data: any) => {
        // console.log('dataaaa', data);
        secureStorage.setItem('location', {
          country: data?.country,
          city: data?.city
        })
      });
    });
  }
}
